import { StammdatenService } from '../../../../../services/stammdaten.service';
import { Component,Input, OnInit} from '@angular/core';
import { StateService } from '@/core/services/state.service';
import { KontaktDisplayModelFormGroup } from '@/api/model-index';
import { IbanValidator } from '@/core/validators/iban-validator';
import { BICValidator } from '@/core/validators/bic-validator';
import { Validators } from '@angular/forms';

@Component({
  selector: 'bank-data-kontakt',
  templateUrl: './bank-data-kontakt.component.html',
  styleUrls: ['./bank-data-kontakt.component.scss']
})
export class BankDataKontaktComponent implements OnInit {
  @Input("form") public kontaktForm: KontaktDisplayModelFormGroup;
  @Input("required") public required: boolean = false;

  constructor(protected stateService: StateService, protected stammdatenService: StammdatenService) {
  }

  ngOnInit(): void {
    if (! this.required) {
      this.stammdatenService.GetPortalKonfiguration().subscribe(cfg => {
        if (cfg != undefined && cfg.ibanueberpruefung == true) {
          this.kontaktForm.Iban.addValidators([new IbanValidator(cfg).validate]);
          this.kontaktForm.Bic.addValidators([new BICValidator(cfg).validate]); 
        }
      });
    }

    if (this.stateService.IsEndvalidationEnabled) {
      if (this.required) {
        this.kontaktForm.Iban.addValidators([Validators.required]);
        this.kontaktForm.Bic.addValidators([Validators.required]); 
        this.kontaktForm.Kontoinhaber.addValidators([Validators.required]); 
        this.kontaktForm.NameDesKreditInstituts.addValidators([Validators.required]); 
      }
      this.kontaktForm.markAllAsTouched();
    }

    // used to bubble the value changes to the top form value
    this.kontaktForm.valueChanges.subscribe(change =>{
      var change = change;
    });
  }

  public appendAsteriskIfRequired(label: string): string {
    return this.required ? label + " *" : label;
  }
}
